import { v4 as uuidv4 } from 'uuid'

const UNIQUE_DEVICE_ID_KEY = 'uniqueDeviceId'

export const getOrCreateUniqueDeviceId = (): string => {
  const existingId = localStorage.getItem(UNIQUE_DEVICE_ID_KEY)
  if (existingId) {
    return existingId
  }
  const newId = uuidv4()
  localStorage.setItem(UNIQUE_DEVICE_ID_KEY, newId)
  return newId
}
